// @flow
import styled from '@emotion/styled'

import Col from './Col';

const ActionsHeaderColumn = styled(Col)`
  display: flex;
  flex-direction: column;
  padding: 0 5px;
  justify-content: space-between;
  max-height: 60px;
`;

export default ActionsHeaderColumn;
